import { optionalPositiveInteger, optionalTrimmedString } from '../../../lib/routeSearch';
import {
  defaultOwnersFilter,
  isOwnerSortProperty,
  ownerPageSizes,
  OwnerSortDirection,
  type OwnerSortProperty,
  type OwnersFilter,
} from './model';

export interface OwnersRouteSearch {
  search?: string;
  page?: number;
  size?: number;
  sortProperty?: OwnerSortProperty | null;
  sortDirection?: OwnerSortDirection;
}

export function ownersRouteSearchSchema(search: Record<string, unknown>): OwnersRouteSearch {
  const searchTerm = optionalTrimmedString(search['search']);
  const page = optionalPositiveInteger(search['page']);
  const parsedSize = optionalPositiveInteger(search['size']);
  const size =
    parsedSize && ownerPageSizes.includes(parsedSize as (typeof ownerPageSizes)[number])
      ? parsedSize
      : undefined;
  const rawSortProperty = optionalTrimmedString(search['sortProperty']);
  const sortProperty =
    rawSortProperty && isOwnerSortProperty(rawSortProperty) ? rawSortProperty : undefined;
  const sortDirection = Object.values(OwnerSortDirection).includes(
    search['sortDirection'] as OwnerSortDirection,
  )
    ? (search['sortDirection'] as OwnerSortDirection)
    : undefined;

  return {
    ...(searchTerm ? { search: searchTerm } : {}),
    ...(page ? { page } : {}),
    ...(size ? { size } : {}),
    ...(sortProperty ? { sortProperty } : {}),
    ...(search['sortProperty'] === null ? { sortProperty: null } : {}),
    ...(sortDirection ? { sortDirection } : {}),
  };
}

export function parseOwnersRouteSearch(search: OwnersRouteSearch): OwnersFilter {
  return {
    searchTerm: search.search ?? '',
    page: search.page ? search.page - 1 : defaultOwnersFilter.page,
    size: search.size ?? defaultOwnersFilter.size,
    sortProperty:
      search.sortProperty === null
        ? null
        : (search.sortProperty ?? defaultOwnersFilter.sortProperty),
    sortDirection: search.sortDirection ?? defaultOwnersFilter.sortDirection,
  };
}

export function serializeOwnersRouteSearch(filter: OwnersFilter): OwnersRouteSearch {
  return {
    ...(filter.searchTerm ? { search: filter.searchTerm } : {}),
    ...(filter.page ? { page: filter.page + 1 } : {}),
    ...(filter.size !== defaultOwnersFilter.size ? { size: filter.size } : {}),
    ...(filter.sortProperty !== defaultOwnersFilter.sortProperty
      ? { sortProperty: filter.sortProperty }
      : {}),
    ...(filter.sortDirection !== defaultOwnersFilter.sortDirection
      ? { sortDirection: filter.sortDirection }
      : {}),
  };
}
